import React from 'react'
import { isArray, isEmpty, isPlainObject, isString } from 'lodash'
import type { TextFeatureVariable } from '../../types'
import { StyledObject } from '../StyledObject'

export type StyledVariableProps = {
  text?: TextFeatureVariable
  defaultCopy?: React.ReactNode
  ignoreStyle?: boolean
}

export const StyledVariable = ({
  text = [],
  defaultCopy = <></>,
  ignoreStyle = false,
}: StyledVariableProps) => {
  if (isEmpty(text)) return <>{defaultCopy}</>

  if (isString(text)) {
    return <StyledObject text={{ copy: text }} ignoreStyle={true} />
  }

  if (isArray(text)) {
    return (
      <>
        {text.map((item, index) => (
          <StyledObject key={index} text={item} ignoreStyle={ignoreStyle} />
        ))}
      </>
    )
  }

  if (isPlainObject(text)) {
    return <StyledObject text={text} ignoreStyle={ignoreStyle} />
  }

  return <>{defaultCopy}</>
}
